import { Helmet } from 'react-helmet';
import { Navigate } from 'react-router-dom';

import { ORIGIN } from '@sorare/core/src/config';
import {
  FOOTBALL,
  FOOTBALL_BESTOFEUROPE,
  FOOTBALL_CAMPAIGNS,
} from '@sorare/core/src/constants/__generated__/routes';
import { useConnectionContext } from '@sorare/core/src/contexts/connection';
import useIsLoggedIn from '@sorare/core/src/hooks/auth/useIsLoggedIn';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

import { Hero } from 'pages/bestofeurope/Hero';

const BestOfEurope = () => {
  const {
    flags: { useBestOfEurope = false },
  } = useFeatureFlags();
  const { signUp } = useConnectionContext();
  const isLoggedIn = useIsLoggedIn();

  if (!useBestOfEurope) {
    return <Navigate to={FOOTBALL} />;
  }
  if (isLoggedIn) {
    return <Navigate to={FOOTBALL_CAMPAIGNS} />;
  }

  return (
    <>
      <Helmet>
        <link rel="canonical" href={`${ORIGIN}${FOOTBALL_BESTOFEUROPE}`} />
      </Helmet>
      <Hero signUp={signUp} fullScreen />
    </>
  );
};
export default BestOfEurope;
